var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout_container"},[_c('el-aside',{staticClass:"aside",attrs:{"width":_vm.nav_width}},[_c('index-meu-component',{staticClass:"menu"})],1),_c('el-container',[_c('el-header',[_c('index-header-component')],1),_c('el-main',{staticClass:"main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }